import { authRequests } from '@/services';
import { saveToken, clearToken, getToken, getRoles, saveRoles } from '@/services/helpers/token';

import * as types from './mutation-types';

export default {
  async login({ commit }, formData) {
    commit(types.SET_ERRORS, null);
    try {
      const { user, token, site, roles } = await authRequests.login(formData);
      saveToken({ token });
      saveRoles({ roles: JSON.stringify(roles) });
      commit(types.SET_USER, { email: user.email, id: user.id });
      localStorage.setItem('siteId', `${site}`);

      if (new URL(window.location).searchParams.has('redirect')) {
        window.location.href = `${new URL(window.location).searchParams.get('redirect')}`;
      } else {
        window.location.href = '/';
      }
    } catch (message) {
      commit(types.SET_ERRORS, message);
    }
  },

  async extractRoles({ commit }) {
    const roles = JSON.parse(getRoles().roles);
    const jwt = getToken().accessToken;

    if (jwt) {
      const user = JSON.parse(atob(jwt.split('.')[1]));
      commit(types.SET_ROLES, roles);
      commit(types.SET_USER, { email: user.email, id: user.id });
    }
  },

  async logout({ commit }) {
    clearToken();
    commit(types.SET_USER, null);
    window.location.href = '/';
  }
};
